/**
 * 登陆页面
 */
// eslint-disable-next-line no-use-before-define
import React, { useEffect, useState } from 'react';
import { Layout, Space, Form, Button, Input, message, Modal, Typography, Select, Carousel, Row, Col } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Lang from 'src/components/common/language';
// import FooterDom from 'src/components/footer';
import { LangMessage } from 'src/store/common/language';
import { ADD_NODE } from 'src/store/common/nodeTree';
import { setUsername, CLEAR_LOGIN } from 'src/store/common/user';
import { RouterLocation } from 'src/router/types';
import { MENUTABS_DELETE_ALL, MenuObject, INIT_MENUTABS_ADD } from 'src/store/common/menuTabs';
import { MDRHomePageRouterConfig } from 'src/router/config/homePage';
import { ACTIVE_MENU } from 'src/store/common/menuTabs';
import { ArrowLeftIcon, ArrowRightIcon } from 'src/components/common/icon/customIcon';
import TitleICON from 'src/assets/imgs/login/login_icon.png';
// import {MD5} from 'crypto-js';
import { user, homePage, common } from 'src/api';
import UserTypes from 'src/api/user/type';
import { MenuTree } from 'src/api/homePage/type';
import { useLocalStorage } from 'react-use';
import { HOME_ROLE_OPT, PUBLIC_RSA_KEY } from 'src/utils/const';
import {
    findMenuRole,
    formatRoleList,
    CascaderData,
    nodeTreeFormatCascader,
} from 'src/utils/function';
import { showLoading, hideLoading } from 'src/components/common/loding';
import { SET_DEFAULT_TIME } from 'src/store/common/serverTime';
import { NEWS_CLEAR } from 'src/store/common/news';
import { cloneDeep } from 'lodash';
// import GLOBALICON from 'src/assets/imgs/common/global-icon.png';
import ENICON from 'src/assets/imgs/common/lang_en.png';
import ESICON from 'src/assets/imgs/common/lang_es.png';
import IconUser from 'src/assets/imgs/common/icon-user.png';
import IconPwd from 'src/assets/imgs/common/icon-pwd.png';
import { RouterConfig } from 'src/router/types';
import CustomIcon from 'src/components/common/icon/customIcon';
import { rsaEncrypt } from 'src/utils/utils';
const { Content, Header } = Layout;
const { confirm } = Modal;
const { Title, Text } = Typography;
const { Option } = Select;


type Props = {
    Mes: LangMessage;
    locale: string;
    location: RouterLocation;
    dispatch: React.Dispatch<any>;
    menuTabs: MenuObject[];
};

type LoginForm = {
    userName: string;
    password: string;
    loginType?: string;
}

type ModifyForm = {
    oldPwd: string;
    newPassword: string;
    twoNewPassword: string;
}

type ArrowProps = {
    type: 'left' | 'right';
    style?: React.CSSProperties;
    className?: string;
    onClick?: React.MouseEventHandler<HTMLElement>;
}

const getMenuData = async () => {
    let res: MenuTree[] = [];

    if (window?.config?.project === 'MDR') {
        res = await homePage.getNewMenuData();
    } else {
        res = await homePage.getPVMSMenuData();
    }
    return res;
};

const Arrow = ({ type, style, className, onClick }: ArrowProps) => {
    if (type === 'left') {
        return <ArrowLeftIcon style={style} className={className} onClick={onClick} />;
    }
    return <ArrowRightIcon style={style} className={className} onClick={onClick}/>;
};

const Login: React.FC<Props> = (props) => {
    const { Mes, locale, location, dispatch, menuTabs } = props;
    // 判断是否是更改密码
    const type = !location.state?.username;
    const history = useHistory();
    const [ form ] = Form.useForm();
    const [ optTypeValue, setOptTypeValue ] = useLocalStorage('optType', 'SYSTEM_LOGIN');
    const [ lang, setLang ] = useState(localStorage.getItem('language') || 'es_ES');
    const [ captcha, setCaptcha ] = useState<string>('');
    const [ captchaLoading, setCaptchaLoding ] = useState<boolean>(false);

    // 重置确认弹窗
    const showConfirm = (username: string, code: number = 1005) => {
        confirm({
            title: Mes['titleLoginIsChangePassword'],
            icon: <ExclamationCircleOutlined />,
            content: code === 1005 ? Mes['textLoginRestPasswordHint'] : Mes['textLoginPasswordExpired'],
            okText: Mes['btnOkok'],
            cancelText: Mes['btnCancelcancel'],
            onOk () {
                history.push('/login', {username}); // 修改密码
            },
            onCancel () {
                console.info('Cancel');
            },
        });
    };

    const lookHome = () => {
        // eslint-disable-next-line init-declarations
        let item: RouterConfig|undefined = MDRHomePageRouterConfig.find((v) => v.key === 'Home');

        if (item) {
            dispatch({
                type: INIT_MENUTABS_ADD,
                value: {
                    key: item?.key || '',
                    title: item?.title || '',
                    route: item?.route || '',
                },
            });
            dispatch({
                type: ACTIVE_MENU,
                value: item?.key || '',
            });
            dispatch({
                type: NEWS_CLEAR,
                value: null,
            });
            history.push(item.route);
        }
    };

    const getNodeTree = (sysNo:string) => common.getNodeByLoginUser(sysNo).then((res) => {
        let nodeTree: CascaderData[] = [];

        nodeTreeFormatCascader({
            nodeList: res,
            rootNode: nodeTree,
            id: res?.[0]?.ID,
        });
        dispatch({
            type: ADD_NODE,
            value: {
                nodeTree: res,
                nodeOpt: nodeTree,
            },
        });
    });

    const getCaptcha = async () => {
        setCaptchaLoding(true);
        try {
            const str = await common.getCaptcha();
            const captchaCode = form.getFieldValue('captcha');

            if (captchaCode) {
                form.setFieldsValue({ captcha: '' });
            }
            setCaptcha(str);
            setCaptchaLoding(false);
        } catch (e) {
            setCaptchaLoding(false);
            message.error(typeof e === 'string' ? e : Mes['messageAlarmRequestfailrequestfail']);
        }
    };

    // 表单提交方法
    // eslint-disable-next-line complexity
    const onFinish = async (values: LoginForm | ModifyForm) => {
        showLoading();
        try {
            if ('password' in values) { // 登陆提交
                if (!/^[a-zA-Z][a-zA-Z0-9_]{3,15}$/.test(values.userName)) {
                    hideLoading();
                    return message.warn(Mes['hintRulesLoginNotLawful']);
                }
                const loginValues: UserTypes.Login = values;
                let formatLang = locale;

                if (formatLang === 'es_ES') {
                    formatLang = 'es_MX';
                }
                loginValues['request_locale'] = formatLang;
                loginValues.languageSet = formatLang;
                // loginValues.password = values.password || MD5(values.password).toString();
                loginValues.password = rsaEncrypt(values.password, PUBLIC_RSA_KEY) || '';

                const res = await user.login(values);

                setOptTypeValue(values.loginType);
                if ([ 1002, 1005 ].includes(res.code)) { // 1005密码需要重置，1002密码过期， 需要修改密码
                    showConfirm(values.userName, res.code);
                } else {
                    const resSess = await Promise.all([
                        user.getUserSessionContent(),
                        getMenuData(),
                        user.getNodeTree(),
                    ]);
                    const roleOpt = cloneDeep(HOME_ROLE_OPT);

                    findMenuRole(resSess[1], roleOpt);
                    const roleObj = formatRoleList(roleOpt);

                    dispatch({
                        type: setUsername,
                        value: {
                            ip: res.ip,
                            moneyUnit: resSess?.[0]?.moneyUnit || '',
                            sysType: res.sysType,
                            subName: res.subName,
                            systemType: res.systemType,
                            webSocketInfo: resSess?.[0].webSocketInfo,
                            operatorType: res.operatorType,
                            sysUser: {
                                operatorName: res?.sysUser?.operatorName || '',
                                operatorId: res?.sysUser?.operatorId || '',
                                operatorGuid: res?.sysUser?.operatorGuid || '',
                                nodeNo: resSess?.[2] || [],
                                groupList: res?.sysUser?.groupList || '',
                                subSys: res?.sysUser?.subSys || '',
                                username: values.userName || '',
                                phone: res?.sysUser?.phone || '',
                                email: res?.sysUser?.email || '',
                            },
                            sysRole: {
                                groupGuid: res?.sysRole?.groupGuid || '',
                                groupName: res?.sysRole?.groupName || '',
                                globeModifyFlag: res?.sysRole?.globeModifyFlag || '0',
                            },
                            menuList: resSess?.[1] || [],
                            roleObj: roleObj,
                        },
                    });
                    let time = resSess?.[0].serverDateTime;
                    let timeZone = resSess?.[0].timeZoneId;

                    await getNodeTree(res.sysType);
                    dispatch({
                        type: SET_DEFAULT_TIME,
                        value: {
                            serverTime: time,
                            timeZone: timeZone,
                        },
                    });
                    if (menuTabs.length > 1) {
                        dispatch({
                            type: MENUTABS_DELETE_ALL,
                            value: true,
                        });
                    }
                    lookHome();
                }
            } else { // 提交修改密码
                if (values.newPassword !== values.twoNewPassword) {
                    hideLoading();
                    return message.warning(Mes['messageAlarmCpwdmegcpwdmeg']);
                }
                const modifyVal: any = {
                    ...values,
                    'username': location.state?.username,
                    // 'password': values.newPassword || MD5(values.newPassword).toString(),
                    // 'oldPwd': values.oldPwd || MD5(values.oldPwd).toString(),
                    'oldPwd': rsaEncrypt(values.oldPwd, PUBLIC_RSA_KEY) || '',
                    'password': rsaEncrypt(values.newPassword, PUBLIC_RSA_KEY) || '',
                };

                delete modifyVal.newPassword;
                delete modifyVal.twoNewPassword;
                const res = await user.setPassword(modifyVal);

                if (!res) {
                    message.success(Mes['messageSuccessModifysuccessmodifysuccess']);
                    dispatch({
                        type: CLEAR_LOGIN,
                        value: false,
                    });
                    history.push('/login');
                    window.location.reload();
                } else {
                    message.error(res);
                }
            }
            hideLoading();
        } catch (e: any) {
            hideLoading();
            getCaptcha();
            message.error(typeof e === 'string' ? e : Mes['messageAlarmRequestfailrequestfail']);
        }
    };

    const backLogin = () => {// 返回登陆
        history.push('/login');
        window.location.reload();
    };

    const useSessionLogin = async () => {
        setCaptchaLoding(true);
        try {
            await user.useSessionLogin();
            const res = await user.getUserSessionContent();
            const userRes = res.onlineDTO;

            if (!userRes || !userRes.sysUser || !userRes.sysUser.operatorGuid) {
                getCaptcha();
                return;
            }
            const resData = await Promise.all([
                user.getNodeTree(),
                getMenuData(),
            ]);
            const roleOpt = [ ...HOME_ROLE_OPT ];

            findMenuRole(resData[1], roleOpt);
            const roleObj = formatRoleList(roleOpt);

            await getNodeTree(userRes.sysType);
            dispatch({
                type: setUsername,
                value: {
                    ip: userRes.ip,
                    sysType: userRes.sysType,
                    subName: userRes.subName,
                    systemType: userRes.systemType,
                    moneyUnit: res.res,
                    webSocketInfo: res.webSocketInfo,
                    operatorType: userRes.operatorType,
                    sysUser: {
                        operatorName: userRes?.sysUser?.operatorName || '',
                        operatorId: userRes?.sysUser?.operatorId || '',
                        operatorGuid: userRes?.sysUser?.operatorGuid || '',
                        nodeNo: resData[0] || [],
                        groupList: userRes?.sysUser?.groupList || '',
                        subSys: userRes?.sysUser?.subSys || '',
                        username: userRes?.sysUser?.operatorId || '',
                        phone: userRes?.sysUser?.phone || '',
                        email: userRes?.sysUser?.email || '',
                    },
                    sysRole: {
                        groupGuid: userRes?.sysRole?.groupGuid || '',
                        groupName: userRes?.sysRole?.groupName || '',
                    },
                    menuList: resData[1],
                    roleObj: roleObj,
                },
            });
            setCaptchaLoding(false);
            lookHome();
        } catch (error) {
            getCaptcha();
            console.info(error);
        }
    };

    useEffect(() => {
        if (type) {// 判断当前账号是否已经登录
            useSessionLogin();
        }
    }, []);

    return (
        <Layout className='login' id='login'>
            <Header>
                <CustomIcon IconName='CFELogo' className='login-logo' />
                <span className='login-title'>{ Mes['labelTitleSystem']}</span>
            </Header>
            <Content className='login-bg' >
                <Carousel
                    autoplay
                    effect='fade'
                    arrows
                    prevArrow={<Arrow type='left' />}
                    nextArrow={<Arrow type='right' />}
                >
                    <div className='bg-1'></div>
                    <div className='bg-2'></div>
                    <div className='bg-4'></div>
                    <div className='bg-5'></div>
                    <div className='bg-6'></div>
                </Carousel>
                <section className='login-content'>
                    <Space direction='vertical' align='center' className='login-info'>
                        <img src={TitleICON} className='logoTitle' />
                        <Title level={3} className='flexCenter' style={{ marginBottom: '0' }}>{ Mes['labelLoginTitle']}</Title>
                        <Text>{ Mes['labelLoginTips']}</Text>
                        {
                        // 登陆
                            type ? (<Form
                                name='normal_login'
                                layout='vertical'
                                labelCol={{ span: 24 }}
                                form={form}
                                initialValues={{ loginType: optTypeValue || 'SYSTEM_LOGIN' }}
                                onFinish={onFinish}>
                                <Space className='login-select' align='center'>
                                    <Space className='login-lang'>
                                        <img src={lang?.includes('es') ? ESICON : ENICON} alt='language' />
                                        <Lang className='blackLang' changeLang={(val: string) => {
                                            setLang(val);
                                        }}/>
                                    </Space>
                                    {
                                        window.config.isDomainLogin ? (<Form.Item
                                            name='loginType'
                                            className='login-type'
                                            rules={[ {required: true} ]}
                                        >
                                            <Select bordered={false}>
                                                <Option value='SYSTEM_LOGIN'>{Mes['labelTitleSystemUser']}</Option>
                                                <Option value='AD_LOGIN'>{ Mes['labelTitleDomainUser'] }</Option>
                                            </Select>
                                        </Form.Item>) : null
                                    }
                                </Space>
                                <Form.Item
                                    label={Mes['titleUserName']}
                                    name='userName'
                                    rules={[
                                        { required: true },
                                        {
                                            validator: (_:any, value:any) => {
                                                if (value?.length >= 4 && value?.length <= 16) {
                                                    return /^[a-zA-Z][a-zA-Z0-9_]{3,15}$/.test(value) ? Promise.resolve() : Promise.reject(Mes['hintRulesLoginNotLawful']);
                                                } else {
                                                    return Promise.resolve();
                                                }
                                            },
                                        },
                                    ]}
                                >
                                    <Input
                                        size='middle'
                                        prefix={<img src={IconUser} title='user' />}
                                        type='text'
                                        placeholder={Mes['titleUserName']}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={Mes['titlePassword']}
                                    name='password'
                                    rules={[ { required: true } ]}>
                                    <Input.Password
                                        size='middle'
                                        prefix={<img src={IconPwd} title='Password' />}
                                        placeholder={Mes['titlePassword']}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={Mes['labelTitleCaptchaCode']}
                                >
                                    <Row gutter={24} className='captcha' align='middle'>
                                        <Col span={15}>
                                            <Form.Item name='captcha' rules={[ { required: true } ]} style={{marginBottom: '0'}}>
                                                <Input
                                                    size='middle'
                                                    placeholder={Mes['labelTitleCaptchaCode']}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={9} >
                                            <Button
                                                type='text'
                                                loading={captchaLoading}
                                                icon={<img src={captcha} alt={Mes['labelTitleCaptchaCode']} />}
                                                title={Mes['labelTitleCaptchaCode']}
                                                onClick={getCaptcha}
                                                style={{display: 'block', height: 'auto'}}
                                            ></Button>
                                        </Col>
                                    </Row>
                                </Form.Item>
                                <Form.Item className='mb0'>
                                    <Button type='primary' htmlType='submit' size='large' title={ Mes['titleLabelLoginoperateloginoperate'] }>
                                        { Mes['titleLabelLoginoperateloginoperate'] }
                                    </Button>
                                </Form.Item>
                            </Form>)
                            // 修改密码
                                : (<Form
                                    name='changePassword'
                                    layout='vertical'
                                    preserve={false}
                                    labelCol={{ span: 24 }}
                                    onFinish={onFinish}>
                                    <Form.Item
                                        label={Mes['titleLabelOldPassword']}
                                        name='oldPwd'
                                        rules={[ { required: true } ]}>
                                        <Input.Password
                                            size='middle' autoComplete='new-password'
                                            prefix={<img src={IconPwd} title='Password' />}
                                            type='text' />
                                    </Form.Item>
                                    <Form.Item
                                        label={Mes['titleLabelNewPassword']}
                                        name='newPassword'
                                        rules={[ { required: true } ]}
                                        extra={(<span style={{color: 'red'}}>{Mes['messageHintChangePassword']}</span>)}>
                                        <Input.Password
                                            size='middle'
                                            autoComplete='new-password'
                                            prefix={<img src={IconPwd} title='Password' />} type='password' />
                                    </Form.Item>
                                    <Form.Item
                                        label={Mes['titlelabelConfirmPassword']}
                                        name='twoNewPassword'
                                        rules={[ { required: true } ]}>
                                        <Input.Password
                                            size='middle'
                                            autoComplete='new-password'
                                            prefix={<img src={IconPwd} title='Password' />} type='password' />
                                    </Form.Item>
                                    <Form.Item className='btnItem'>

                                        <Button type='primary' size='large' htmlType='submit' title={ Mes['btnUpdatePassword'] } className='btn'>
                                            {Mes['btnUpdatePassword']}
                                        </Button>
                                        <Button size='large' onClick={backLogin} title={Mes['btnBackLogin']} className='btn' style={{marginLeft: '10px'}}>
                                            {Mes['btnBackLogin']}
                                        </Button>
                                    </Form.Item>
                                </Form>)
                        }
                    </Space>
                </section>
                <span className='copyright'>{Mes['labelTitleCopyright']}</span>
            </Content>
        </Layout>
    );
};

export default connect((state: any) => ({
    Mes: state.langSwitch.message,
    locale: state.langSwitch.locale,
    menuTabs: state.menuTabsDispose.menuTabs,
}))(Login);
